import React from "react";
import NewsDetail from "./NewsDetail";

const NewsDetailIndex = () => {
  return <NewsDetail />;
};

export default NewsDetailIndex;
